module.exports = __webpack_public_path__ + "img/2.73c43452.png";